<template>
  <div class="website" ref="website" @scroll="onScroll">
    <template v-if="false">
      <Head :scrollTop="scrollTop"></Head>
      <download></download>
      <introduce></introduce>
      <bottom v-if="versionInfo" :versionInfo="versionInfo"></bottom>
      <Footer></Footer>
      <backToTop :scrollTop="scrollTop" @backToTop="handleBackToTop"></backToTop>
    </template>
    <template>
      <div class="tips">
        尊敬的用户：您好！我们遗憾地通知您，本平台将于12月31日下线微信、手机号登录平台，微信及手机号登录用户请您在此之前完成数据备份，以免造成不便。感谢您的理解与支持！
      </div>
    </template>
  </div>
</template>

<script>
import banner from "./components/banner";
import Head from "./components/header";
import download from "./components/download";
import introduce from "./components/introduce";
import bottom from "./components/bottom";
import Footer from "./components/footer";
import backToTop from "./components/backToTop";
import { uploadBussinessLog } from "@/js/utils/bussinessLog";
export default {
  name: "Website",
  data() {
    return {
      ticking: false,
      scrollTop: 0,
      versionInfo: null
    };
  },
  components: {
    banner,
    Head,
    download,
    introduce,
    bottom,
    Footer,
    backToTop
  },
  created() {
    this.versionHistoryList();
    document.title = "晓讲师";
    uploadBussinessLog("d27553eb292b65fe3ba9e49ce3a0aae4", "loading");
  },
  methods: {
    onScroll(e) {
      let that = this;
      let { ticking, scrollTop } = this;
      if (!ticking) {
        window.requestAnimationFrame(function() {
          that.scrollTop = e.target.scrollTop;
          ticking = false;
        });

        ticking = true;
      }
    },
    handleBackToTop() {
      this.scrollTop = 0;
      this.$refs.website.scrollTop = 0;
    },
    versionHistoryList() {
      this.$api
        .versionHistoryList()
        .then(result => {
          if (result.success) {
            this.versionInfo = result.data;
          }
        })
        .catch(err => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.website {
  height: 100vh;
  overflow: auto;
  .tips {
    color: #666;
    font-size: 14px;
    padding: 10px 0;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/website/index.vue